import { render, staticRenderFns } from "./MunicipalityMapPolygons.vue?vue&type=template&id=296d6fff&scoped=true&"
import script from "./MunicipalityMapPolygons.vue?vue&type=script&lang=js&"
export * from "./MunicipalityMapPolygons.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityMapPolygons.vue?vue&type=style&index=0&id=296d6fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d6fff",
  null
  
)

export default component.exports